var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.logo.name === 'LogoBrr')?_c('img',{attrs:{"src":require("@/components/logos/logo-home.png"),"width":"130"}}):_c(_vm.logo.name,{tag:"component",staticClass:"img-fluid",attrs:{"width":_vm.logo.width,"height":_vm.logo.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }